export const SectionSkeleton = () => (
  <div className="border-b border-black/10 py-6 animate-pulse">
    <div className="h-6 w-1/3 rounded bg-neutral-200" />
    <div className="mt-4 grid gap-6 md:grid-cols-[2fr_1fr]">
      <div className="space-y-4">
        <div className="h-48 w-full rounded bg-neutral-200 md:h-64" />
        <div className="space-y-2">
          <div className="h-4 w-3/4 rounded bg-neutral-200" />
          <div className="h-4 w-2/3 rounded bg-neutral-200" />
        </div>
      </div>
      <div className="space-y-3">
        {Array.from({ length: 3 }).map((_, idx) => (
          <div key={idx} className="flex gap-3">
            <div className="h-16 w-24 rounded bg-neutral-200" />
            <div className="flex-1 space-y-2">
              <div className="h-4 w-5/6 rounded bg-neutral-200" />
              <div className="h-4 w-2/3 rounded bg-neutral-200" />
            </div>
          </div>
        ))}
      </div>
    </div>
    <div className="mt-6 grid gap-4 md:grid-cols-3">
      {Array.from({ length: 3 }).map((_, idx) => (
        <div key={idx} className="space-y-2">
          <div className="h-20 w-full rounded bg-neutral-200" />
          <div className="h-4 w-3/4 rounded bg-neutral-200" />
        </div>
      ))}
    </div>
  </div>
)
